<template>
  <div class="profile-page">
    <div class="name-wrapper">
      <div class="image-placeholder flex-c">
        {{ userName.slice(0, 1).toUpperCase() }}
      </div>
      <div class="text">
        <div class="name">{{ userName }}</div>
        <div class="plan">{{ userType }} plan</div>
      </div>
    </div>
    <div class="credits-wrap">
      <div class="credit" v-if="!lbCreditsPlan">
        <div class="text">
          <span v-if="views && views >= 10000000">Unlimited</span>
          <span v-if="views && views < 10000000">{{
            views | formatNumber
          }}</span>
          <p>Views left</p>
          <span v-if="!views">0</span>
        </div>
      </div>
      <div class="credit email" v-if="lbCreditsPlan">
        <div class="circle-wrap">
          <span class="icon-wrap"><Email-Icon /></span>
          <div
            class="slice"
            :style="{
              clip:
                emailUsage > 50
                  ? 'rect(auto, auto, auto, auto)'
                  : 'rect(0em, 76px, 76px, 38px)',
            }"
          >
            <div
              class="bar"
              :style="{
                transform: 'rotate(' + (emailUsage / 100) * 360 + 'deg)',
              }"
            ></div>
            <div
              class="fill"
              :style="{ display: emailUsage >= 50 ? 'block' : 'none' }"
            ></div>
          </div>
        </div>
        <div class="text">
          <span v-if="credits && credits >= 10000000">Unlimited</span>
          <span v-if="credits < 10000000">{{ credits | formatNumber }}</span>
          <p>credits left</p>
        </div>
      </div>
      <div class="credit phone" v-if="lbCreditsPlan && phoneCreditsAlloted > 0">
        <div class="circle-wrap">
          <span class="icon-wrap"><Phone-Icon /></span>
          <div
            class="slice"
            :style="{
              clip:
                phoneUsage > 50
                  ? 'rect(auto, auto, auto, auto)'
                  : 'rect(0em, 76px, 76px, 38px)',
            }"
          >
            <div
              class="bar"
              :style="{
                transform: 'rotate(' + (phoneUsage / 100) * 360 + 'deg)',
              }"
            ></div>
            <div
              class="fill"
              :style="{ display: phoneUsage >= 50 ? 'block' : 'none' }"
            ></div>
          </div>
        </div>
        <div class="text">
          <span v-if="phoneCredits && phoneCredits >= 10000000">Unlimited</span>
          <span v-if="phoneCredits < 10000000">{{
            phoneCredits | formatNumber
          }}</span>
          <p>credits left</p>
        </div>
      </div>
      <button
        class="upgrade"
        title="Upgrade"
        @click="redirectPricing"
        v-if="!isPaidUser"
      >
        Upgrade now
      </button>
    </div>
    <div class="link-section">
      <a :href="advSearchLink" target="_blank"
        ><Account-Icon viewBox="0 0 18 22" class="account-icon" />Advanced
        search</a
      >
      <a :href="listLink" target="_blank"
        ><List-Icon viewBox="0 0 24 24" />View lists</a
      >
      <a :href="integrationsLink" target="_blank"
        ><Settings-Icon viewBox="0 0 24 24" />Connect Integration</a
      >
      <a :href="termsLink" target="_blank">Terms of Service</a>
      <a :href="privacylink" target="_blank">Privacy Notice</a>
    </div>
  </div>
</template>

<script>
import emailIcon from '@/assets/icons/svg/email.svg'
import phoneIcon from '@/assets/icons/svg/phone.svg'

import AccountIcon from '@/assets/icons/svg/account-2.svg'
import ListIcon from '@/assets/icons/svg/list.svg'
import SettingsIcon from '@/assets/icons/svg/settings.svg'

import sharedFunctions from '@/assets/util/functions.js'
import { MxEvent } from '@/assets/util/constants/analytics.js'
import { BASE_URL_NEW, BASE_URL } from '@/assets/util/constants/constants.js'

export default {
  name: 'Profile',
  components: {
    'Email-Icon': emailIcon,
    'Phone-Icon': phoneIcon,
    'Account-Icon': AccountIcon,
    'List-Icon': ListIcon,
    'Settings-Icon': SettingsIcon,
  },
  data: function () {
    return {
      advSearchLink: BASE_URL_NEW + '/advanced-search/contact#search',
      listLink: BASE_URL_NEW + '/my-leads',
      integrationsLink: BASE_URL_NEW + '/integrations',
      termsLink: BASE_URL + '/termsAndConditions.htm',
      privacylink: BASE_URL + '/privacy.htm',
    }
  },
  computed: {
    userName() {
      return (
        this.$store.state.header.name.trim() || this.$store.state.header.email
      )
    },
    views() {
      return this.$store.state.header.views
    },
    userType() {
      return this.$store.state.header.userType.toLowerCase()
    },
    downloads() {
      return this.$store.state.header.downloads
    },
    lbCreditsPlan() {
      return this.$store.state.header.lbCreditsPlan
    },
    credits() {
      return this.$store.state.header.credits
    },
    phoneCredits() {
      return this.$store.state.header.phoneCredits
    },
    isPaidUser() {
      return this.$store.state.header.isPaidUser
    },
    lbCreditsAllotted() {
      return this.$store.state.header.lbCreditsAllotted
    },
    phoneCreditsAlloted() {
      return this.$store.state.header.phoneCreditsAlloted
    },
    emailUsage() {
      return (
        ((this.lbCreditsAllotted - this.credits) / this.lbCreditsAllotted) * 100
      )
    },
    phoneUsage() {
      return (
        ((this.phoneCreditsAlloted - this.phoneCredits) /
          this.phoneCreditsAlloted) *
        100
      )
    },
  },
  methods: {
    redirectPricing() {
      sharedFunctions.track(
        MxEvent.upgradeHeaderRocket,
        null,
        this.$store.state
      )
      window.open(`${BASE_URL_NEW}/pricing`)
    },
  },
}
</script>

<style scoped lang="scss">
.profile-page {
  padding: 16px;

  .name-wrapper {
    display: flex;
    align-items: center;
    .image-placeholder {
      margin-right: 20px;
      width: 50px;
      height: 50px;
      background: #ffffff;
      border: 1px solid rgba(102, 112, 128, 0.1);
      border-radius: 50%;
      justify-content: center;
      color: #667080;
      font-size: 18px;
    }
    .name {
      font-size: 18px;
      line-height: 32px;
      color: #495567;
    }
    .plan {
      text-transform: capitalize;
      font-size: 14px;
      line-height: 24px;
      color: #667080;
    }
  }
  .credits-wrap {
    background: #ffffff;
    border: 1px solid rgba(102, 112, 128, 0.2);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 20px;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 15px;

    .credit {
      width: calc(50% - 15px);
      display: flex;
      flex-direction: column;
      align-items: center;

      &.email {
        .circle-wrap {
          background: #2648f7;
        }
        .icon-wrap svg {
          fill: #2648f7;
        }
      }
      &.phone {
        .circle-wrap {
          background: #ff4788;
        }
        .icon-wrap svg path {
          stroke: #ff4788;
        }
      }
      .circle-wrap {
        margin-bottom: 10px;
        width: 76px;
        height: 76px;
        position: relative;
        border-radius: 50%;
        &::after {
          position: absolute;
          top: 6px;
          left: 6px;
          display: block;
          content: ' ';
          border-radius: 50%;
          background-color: #ffffff;
          width: 64px;
          height: 64px;
        }
        .icon-wrap {
          position: absolute;
          inset: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1;
        }
        .slice {
          clip: rect(auto, auto, auto, auto);
          width: 76px;
          height: 76px;
          position: absolute;
        }
        .bar,
        .fill {
          position: absolute;
          border-radius: 50%;
          border: 6px solid #f0f1f3;
          width: 76px;
          height: 76px;
          clip: rect(0px, 38px, 76px, 0px);
        }

        .fill {
          transform: rotate(180deg);
        }
      }
      .text {
        font-size: 16px;
        line-height: 22px;
        color: #495567;
        letter-spacing: -0.02em;
        gap: 3px;
        text-align: center;
        span {
          font-family: 'Figtree-Medium';
        }
        p {
          display: inline;
          margin: 0 0 0 3px;
        }
      }
    }
  }
  .upgrade {
    margin-top: 5px;
    background: rgba(38, 72, 247, 0.1);
    border-radius: 6px;
    font-size: 14px;
    line-height: 20px;
    color: #2648f7;
    padding: 7px;
    border: 0;
    width: 100%;
    font-family: 'Figtree-Medium';
  }
  .link-section {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;
    a {
      font-size: 16px;
      line-height: 24px;
      color: #495567;
      display: flex;
      gap: 10px;
      align-items: center;
      svg {
        width: 18px;
        height: 18px;
      }
      &:hover {
        color: $primary-color;
        svg path {
          stroke: $primary-color;
        }
        .account-icon path {
          fill: $primary-color;
          stroke: none;
        }
      }
    }
  }
}
</style>
